import { Image, Video } from '@perxis-auto/ui-kit/lib/components/Gallery';

import { ExtendedCarItemType } from '@/interfaces/cars.interfaces';

import { getImageSizes } from './getCarImages';
import getCarTitle from './getCarTitle';

enum YoutubePreviewSizeEnum {
  xs = 'default',
  sm = 'mqdefault',
  md = 'hqdefault',
  lg = 'sddefault',
  xl = 'maxresdefault',
}

const YOUTUBE_PREVIEW_SIZE_MAP: Record<YoutubePreviewSizeEnum, number> = {
  [YoutubePreviewSizeEnum.xs]: 120,
  [YoutubePreviewSizeEnum.sm]: 320,
  [YoutubePreviewSizeEnum.md]: 480,
  [YoutubePreviewSizeEnum.lg]: 640,
  [YoutubePreviewSizeEnum.xl]: 1280,
};

function getIDfromURL(url: string) {
  if (!url) {
    return null;
  }

  const re =
    /(https?:\/\/)?(((m|www)\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;

  const match = url.match(re);

  if (match && match[8].length === 11) {
    return match[8];
  }

  console.log('The supplied URL is not a valid youtube URL');

  return null;
}

const transformUrl = (videoId: string) => {
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&showinfo=0`;
};

const getYoutubePreview = (videoId: string, size: YoutubePreviewSizeEnum): string => {
  return `https://img.youtube.com/vi/${videoId}/${size}.jpg`;
};

const transformYoutubePreview = (videoId: string, title: string): Image => {
  return {
    sizes: getImageSizes('card').join(','),
    title,
    original: getYoutubePreview(videoId, YoutubePreviewSizeEnum.xl),
    thumbnail: getYoutubePreview(videoId, YoutubePreviewSizeEnum.sm),
    srcSet: Object.entries(YOUTUBE_PREVIEW_SIZE_MAP)
      .map(([size, width]) => {
        return `${getYoutubePreview(videoId, size as YoutubePreviewSizeEnum)} ${width}w`;
      })
      .join(','),
  };
};

export const getCarVideos = (extendedData: ExtendedCarItemType): Array<Video> => {
  const { videos } = extendedData.data;
  const title = getCarTitle(extendedData);

  if (videos && videos.length) {
    const videoIds: string[] = [];

    for (const video of videos) {
      const videoId = getIDfromURL(video);

      if (videoId) {
        videoIds.push(videoId);
      }
    }

    return videoIds.map(videoId => ({
      url: transformUrl(videoId),
      preview: transformYoutubePreview(videoId, title),
    }));
  }

  return [];
};

export default getCarVideos;
